import React, {useEffect} from "react";
import {Link} from "react-router-dom";

function BowlManiaRules() {

    useEffect(() => {
        document.title = "BowlMania Rules";
    }, []);

    return (
        <div>
            <h4>BowlMania Contest Rules</h4>
            <div>
                <p>Rules:
                    <ol>
                        <li>All picks must be submitted before the start of the first bowl game</li>
                        <li>Once the first bowl game starts, all picks will be visible on the main page</li>
                        <li>The overall prize goes to the entry with the highest total points (sum of confidence points of winning picks).</li>
                        <li>If multiple entries tie they will split the prize.</li>
                    </ol>
                </p>
            </div>
            <Link className="ContestLink" to="/bowlmania" key='link-mainpage'>Return to the main page</Link>
        </div>
    );
}

export default BowlManiaRules;
